import EditSurveyDialog from './editSurveyDialog.container'

export default EditSurveyDialog